import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './KeyActions.styles.scss';

type KeyActionsProps = {
  className?: string;
  description: string;
};

const KeyActions: React.FC<KeyActionsProps> = (props) => {
  const { children, className, description } = props;

  const classes = classNames('key-actions', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <span className="key-actions__title">{t('keyActions')}</span>
      <p className="key-actions__description">{description}</p>
      <div className="key-actions__buttons">{children}</div>
    </div>
  );
};

export default KeyActions;
